import pipe from 'lodash/fp/pipe.js';
import Components from '#components/pages/Models/Components/Components.jsx';
import withRouteParams from '#components/support/routing/withRouteParams/index.jsx';
import withLocation from '#components/support/routing/withLocation/index.jsx';

export default pipe(withRouteParams, withLocation)(Components);
